<template>
  <div class="welcome" style="height:1150px;min">
    
    <div class="bgc">
      <p>欢迎使用欧雅陶瓷后台管理系统</p>
    </div>
     
  </div>
</template>

<script>
import table from '@/mixins/tables'
export default {
   data () {
    return {
      center:{lng:119.315874,lat:26.062792},
      zoom:11, 
      pointList:[],
      editID:0,
      tableData: [],
      form: {
          name: '',
          IMEI: '',
          speed: '',
          lj: '',
          speedTime: '',
          time: '',
          stateDesc:''
        },
      waterCloumn: [
        { name: 'name', label: '取水点', minWidth: '160px' },
        { name: 'stateDesc', label: '状态', maxWidth: '120px' },
      ],
      waterMonitorData: [
        { time: "1:00", value: 3 },
        { time: "2:00", value: 4 },
        { time: "3:00", value: 3.5 },
        { time: "4:00", value: 5 },
        { time: "5:00", value: 4.9 },
        { time: "6:00", value: 6 },
        { time: "7:00", value: 7 },
        { time: "8:00", value: 9 },
        { time: "9:00", value: 13 },
        { time: "1:00", value: 3 },
        { time: "2:00", value: 4 },
        { time: "3:00", value: 3.5 },
        { time: "4:00", value: 5 },
        { time: "5:00", value: 4.9 },
        { time: "6:00", value: 6 },
        { time: "7:00", value: 7 },
        { time: "8:00", value: 9 },
        { time: "9:00", value: 13 },
        { time: "1:00", value: 3 },
        { time: "2:00", value: 4 },
        { time: "3:00", value: 3.5 },
        { time: "4:00", value: 5 },
        { time: "5:00", value: 4.9 },
        { time: "6:00", value: 6 },
        { time: "7:00", value: 7 },
        { time: "8:00", value: 9 },
        { time: "9:00", value: 13 },
        { time: "10:00", value: 3 },
        { time: "11:00", value: 4 },
        { time: "12:00", value: 3.5 },
        { time: "13:00", value: 5 },
        { time: "14:00", value: 4.9 },
        { time: "6:00", value: 6 },
        { time: "7:00", value: 7 },
        { time: "8:00", value: 9 },
        { time: "9:00", value: 13 },
        { time: "1:00", value: 3 },
        { time: "2:00", value: 4 },
        { time: "3:00", value: 3.5 },
        { time: "4:00", value: 5 },
        { time: "5:00", value: 4.9 },
        { time: "6:00", value: 6 },
        { time: "7:00", value: 7 },
        { time: "8:00", value: 9 },
        { time: "9:00", value: 13 }
      ],
      pieChart: undefined,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      dateValue: []
    }
  },
  mixins: [table],
  created() {
    /*
    this.getList();
    // 动态加载时间
    const timer = setInterval(() => {
      this.getPlaceData();
    },60 * 1000);
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
    end.setTime(end.getTime() - 3600 * 1000 * 24);
    //const end = new Date();
    //end.setTime(end.getTime() - 3600 * 1000 * 24);
    this.dateValue = [start,end];
    */
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
        if (row.state === 1) {
          return 'warning-row';
        } 
        return 'success-row';
      },
    getList() {
      var that = this;
      this.$post('/apis/manage/place/getPlace',{
              page:that.queryInfo.pagenum-1,
              length:that.queryInfo.pagesize,
              token:sessionStorage.getItem('token'),
              name:that.queryInfo.query
          }).then(function(res){
            if(res.errno == 0){
              var data = res.data;
              var newList = [];
              var newList2 = [];
              for(var i=0;i<data.list.length;i++){
                newList.push({
                  id:data.list[i].id,
                  name: data.list[i].name,
                  state: data.list[i].state,
                  stateDesc: data.list[i].stateDesc,
                  lat:data.list[i].lat,
                  lng:data.list[i].lng,
                })
              }
              console.log(newList);
              that.pointList = newList;
              that.tableData = newList;
              that.total = data.totalCount;
              if(data.list.length>0){
                that.editID = data.list[0].id
                that.center = {lng:data.list[0].lng,lat:data.list[0].lat}
                that.getPlaceData();
                that.getData();
              }
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          })
    },
    getPlaceData() {
      var that = this;
      if(that.editID > 0){
        this.$post('/apis/manage/place/getPlaceData',{
              token:sessionStorage.getItem('token'),
              place_id:that.editID
          }).then(function(res){
            if(res.errno == 0){
              var data = res.data;
              that.form = {
                name: data.name,
                IMEI: data.IMEI,
                speed: data.speed + ' m³/h',
                lj: data.lj + ' m³',
                speedTime: data.speedTime,
                stateDesc: data.stateDesc,
                time: data.time
              }
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          })
      }
    },
    gotoNow(id) {
      sessionStorage.setItem("selectType", 1);
      sessionStorage.setItem("selectSuidao", this.editID);
      this.$router.push('/now')
    },
    gotoHistory(id){
      sessionStorage.setItem("selectType", 1);
      sessionStorage.setItem("selectSuidao", this.editID);
      this.$router.push('/history')
    },
    getID(id){
      this.editID = id;
    },
    handleCurrentChange2(val) {
        console.log(val);
        this.editID = val.id
        this.center = {lng:val.lng,lat:val.lat}
        this.getPlaceData();
        this.getData()
    },
    queryDate() {
      console.log(this.dateValue);
      this.getData();
    },
    dataToStr(date) {
      var year = date.getFullYear(); //年
      var month = date.getMonth()+1; //月
      var day = date.getDate(); //日
      if(month < 10){
        month = '0'+month;
      }
      if(day < 10){
        day = '0'+day;
      }
      return year + "-" + month + "-" + day;
    },
    getData() {
      var that = this;
      this.$post("/apis/manage/place/getPlaceTimeData", {
        token:sessionStorage.getItem('token'),
        place_id:that.editID,
        startTime: this.dataToStr(this.dateValue[0]),
        endTime: this.dataToStr(this.dateValue[1])
      })
        .then(function(res) {
          if (res.errno == 0) {
            var data = res.data;
            var newData = [];
            for(var i=0;i<data.length;i++){
              newData.push({
                time:data[i].time,
                value:parseFloat(data[i].value)
              })
            }
            that.waterMonitorData = newData;
            that.showData();
          }
        })
        .catch(function(err) {
          window.console.log(err);
        });
    },
    // 导出excel格式
    exportExcel() {
      // 树结构转一维数组
      let arr = this.waterMonitorData
      console.log(arr);
      require.ensure([], () => {
        const {export_json_to_excel} = require('@/excel/Export2Excel')
        const tHeader = ['日期', '流量(m³)']
        const filterVal = ['time', 'value'];
        const list = arr
        const data = this.formatJson(filterVal, list)
        console.log('data');
        console.log(data);
        var title = sessionStorage.getItem("companyName") + '('+sessionStorage.getItem("selectPlaceName") +')';
        var startTime = this.dataToStr(this.dateValue[0])
        var endTime = this.dataToStr(this.dateValue[1])
        if(startTime == endTime){
          title += ('_'+startTime);
        }else{
          title += ('_'+startTime+'~'+endTime);
        }
        title += '流量数据'
        export_json_to_excel(tHeader, data, title)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    showData() {
      const pieChartHeight = 500;
      if (this.pieChart == undefined) {
        console.log(54444);
        this.pieChart = new G2.Chart({
          container: "water",
          forceFit: true,
          height: pieChartHeight,
          width:'90%',
          padding: [60, 30, 60, 50]
        });
      }
      
      this.pieChart.clear();
      this.pieChart.source(this.waterMonitorData);
      this.pieChart.scale("value", {
        // 度量
        min: 0 // Y轴显示的最小值
      });
      this.pieChart.scale("time", {
        // 度量
        range: [0, 1] // 数值范围区间
      });
      this.pieChart.tooltip({
        // 提示信息
        crosshairs: {
          type: "line" // 提示信息类型
        },
        itemTpl: '<li><span>流量: {value}(m³)</span></li>'
      });
      this.pieChart.line().position("time*value"); // 几何标记类型   线，  position:二维坐标系内设至 x轴 y轴
      this.pieChart
        .point()
        .position("time*value")
        .size(4)
        .shape("circle")
        .style({
          // 几何标记类型   点，  二维坐标系内设置 x轴 y轴    大小   图形形状
          stroke: "#133049",
          lineWidth: 1
        });
      this.pieChart.render(); // 渲染
      console.log(222);
    }
  }
}
</script>

<style lang="less" scoped>
.formMsg{
  position: absolute;
  width: 90%;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 50px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

.warning-row {
    background: rgb(255 250 205);
  }

 .success-row {
    background: #f0f9eb;
  }
.bm-view {
  width: 70%;
  height: 100%;
  position: absolute;
  left: 28%;
  display: inline-block;
}
  .welcome {
    width: 100%;
    height: 100%;
    position: relative;
    .bgc {
      width: 72%;
      height: 72%;
      background: hsla(0,0%,100%,.25) border-box;   
      overflow: hidden;   
      border-radius: .3em;   
      box-shadow: 0 0 0 1px hsla(0,0%,100%,.3) inset,   
                  0 .5em 1em rgba(0, 0, 0, 0.2);   
      border-radius: 6px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);     
      p {
        position: absolute;
        top: 18%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        margin: 0 auto;
        font-size: 3rem;
        color: rgb(129, 149, 165);
        letter-spacing: 2px;
      }
    }
  }
 
.s_title {
  width: 100%;
  height: 48px;
  display: flex;
  .title_l {
    line-height: 30px;
    flex: 1;
    border-radius: 2px;
    font-size: 18px;
    text-align: center;
    color: rgb(143, 185, 196);
    box-shadow: 0px 0px 21px rgb(152, 175, 182) inset;
  }
  .title_r {
    padding-top: 8px;
    flex: 3;
    display: flex;
    justify-content: space-around;
  }
}
.lineChart_wrap {
  width: 98%;
  height: calc(100% - 60px);
  margin: 0 auto;
  // 日期选择器
  /deep/.el-input__inner {
    background: 000;
    border: 1px solid #227ead;
    border-radius: 6px;
    color: #adadad;
  }
  /deep/.el-range-input {
    background-color: #fff;
    color:#133049;
  }
  /deep/.el-range-separator {
    color: #dedede;
  }
  /deep/.el-picker-panel__sidebar {
    background-color: #133049;
  }
}

</style>